import React from 'react';
import { Text } from 'react-native';

//= ========================================================================

const Title = ({
  children, marginBottom = 16, marginTop = 0, isBold,
}) => (
  <Text style={children ? {
    marginBottom,
    marginTop,
    fontSize: 20,
    fontFamily: isBold ? 'Quicksand-Bold' : 'Quicksand-SemiBold',
  } : {}}
  >
    {children}
  </Text>
);
export default Title;
